export default {
	path: '/company',
	redirect: '/company',
	component: () => import('@/views/layout/Default'),
	children: [
		{
			path: '/',
			name: 'companyHome',
			component: () => import('@/views/mng/Company'),
		},
	],
};
